<template>
    <div class="main homepage-layout" :class="homepageClass">
        <LandingPageBuilder :response="response" :recentFlowers=[] :coupon="apiCoupon" :locale="locale" :trustpilotLocale="trustpilotLocale" :delivery="delivery"></LandingPageBuilder>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LandingPageBuilder } from '@freddiesflowers/frontend-component-library';
import CouponService from '@/services/coupons/CouponService';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'Homepage',
    created() {
        this.$root.$off('change-route');
        this.$root.$on('change-route', (route) => {
            this.$router.push({ name: route });
        });
        if (this.couponCode !== null) {
            this.fetchCouponCodeFromApi();
        }

        if (this.$globalQueryParams?.cms && this.$globalQueryParams.cms !== 'journey-coupon-homepage') this.homepage = this.$globalQueryParams.cms;

        this.homepage = this.isProduction ? this.homepage : `uat-${this.homepage}`;
        this.getHomepage();
    },
    mounted() {
        this.$store.dispatch('cookies/mountTrustPilot');
        this.$store.dispatch('cookies/mountTrustedShops');
    },
    computed: {
        ...mapGetters({
            couponCode: 'register/getFriendCode',
            locale: 'localisation/getSelectedLocale',
            cmsLocale: 'localisation/getCmsLocaleKey',
            hasAcceptedCookies: 'cookies/getHasAnsweredCookieForm',
        }),
        isProduction() {
            return process.env.VUE_APP_ENV === 'Production';
        },
        hasCoupon() {
            return this.apiCoupon && this.apiCoupon.code !== null;
        },
        delivery() {
            return this.$globalQueryParams?.dci === '1';
        },
        homepageClass() {
            return !this.hasAcceptedCookies ? 'homepage-padding' : '';
        },
    },
    data() {
        return {
            page_title: 'Home',
            response: [],
            apiCoupon: null,
            homepage: 'main-homepage',
            trustpilotLocale: process.env.VUE_APP_TRUSTPILOT_LOCALE,
        };
    },
    methods: {
        fetchCouponCodeFromApi() {
            CouponService.getCouponByCouponCode(this.couponCode, this.delivery)
                .then(response => {
                    this.$store.commit('register/setCouponProperties', response.data.properties);
                    this.apiCoupon = response.data.properties;
                })
                .catch(error => console.error(error));
        },
        getHomepage() {
            getButterCmsPage(this.homepage).then((res) => this.response = res);
        },
    },
    components: {
        LandingPageBuilder,
    },
};
</script>
